import { render } from "./RimacomiProfile.vue?vue&type=template&id=749a6336&scoped=true&ts=true"
import script from "./RimacomiProfile.vue?vue&type=script&lang=ts"
export * from "./RimacomiProfile.vue?vue&type=script&lang=ts"

import "./RimacomiProfile.vue?vue&type=style&index=0&id=749a6336&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src845797062/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749a6336"]])

export default __exports__